// removed by extract-text-webpack-plugin
module.exports = {"MulchTypes":"MulchTypes__MulchTypes__3STAy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/MulchTypes/MulchTypes.css
// module id = 242
// module chunks = 1